export default __webpack_public_path__ + "static/media/Ms. Aartee Satpathy.9aa0f0c5.png";